<div>
    <nz-row nzJustify="space-between" nzAlign="middle" style="margin-bottom: 8px;">
        <nz-col>
            <h2>Pricing</h2>
            @if (userClientTypes.includes(3) && userClientTypes.length === 1) {
                <p>Manage your pricing that will be used by call centres and fleet operators to estimate costs and make informed decisions.</p>
            }
            @if (userClientTypes.includes(2)) {
                <p>Set up and manage pricing templates that will simplify pricing for different clients.</p>
            }
            
        </nz-col>
        @if (userClientTypes.includes(2)) {
        <nz-col>
            <button nz-button (click)="addPricingTemplate()">Add New Pricing Template</button>
        </nz-col>
        }
    </nz-row>

    <nz-tabs [(nzSelectedIndex)]="selectedIndex" (nzAdd)="addPricingTemplate()" [nzHideAdd]="userClientTypes.includes(3) && userClientTypes.length === 1" nzType="editable-card">
        @for (template of pricingTemplates(); track template.pricingTemplateId) {
        <nz-tab [nzTitle]="template.pricingName" >
            <nz-card>
                @if(userClientTypes.includes(2)) {
                    <ng-container *ngTemplateOutlet="CallCentreTemplateHeader"></ng-container>
                    }
                @if(userClientTypes.includes(3) && userClientTypes.length === 1) {
                    <ng-container *ngTemplateOutlet="SPTemplateHeader"></ng-container>
                    }
                

                    <ng-template #CallCentreTemplateHeader>
                        <nz-card [nzBordered]="false" style="background-color: #fafafa;">
                            <nz-card-meta
                                style="margin-bottom: 16px;"
                                nzTitle="Template Configuration"
                                nzDescription="Define the template details and default gross profit percentage for pricing calculations."
                            ></nz-card-meta>
                            <nz-row nzGutter="16" style="margin-bottom: 16px;">
                                <nz-col nzSpan="8">
                                    <nz-form-item style="margin-bottom: 0;">
                                        <nz-form-label nzRequired>Template Name</nz-form-label>
                                        <nz-form-control nzExtra="To identify template when invoicing">
                                            <input nz-input [(ngModel)]="template.pricingName" placeholder="Enter template name" />
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>
                                <nz-col nzSpan="8">
                                    <nz-form-item style="margin-bottom: 0;">
                                        <nz-form-label>Description</nz-form-label>
                                        <nz-form-control nzExtra="Optional: Provide additional details about the template">
                                            <input nz-input [(ngModel)]="template.description" placeholder="Enter description (optional)" />
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>
                                <nz-col nzSpan="8">
                                    <nz-form-item style="margin-bottom: 0;">
                                        <nz-form-label nzRequired>
                                            Fixed GP %
                                            <i nz-icon nzType="info-circle" nzTheme="outline" 
                                            nz-tooltip="Default gross profit percentage. Individual items can override this with fixed prices."
                                            style="margin-left: 4px; color: #1890ff; cursor: help;"></i>
                                        </nz-form-label>
                                        <nz-form-control nzExtra="Default gross profit percentage.">
                                            <input 
                                                nz-input 
                                                type="number" 
                                                [(ngModel)]="template.pricingValue" 
                                                placeholder="%" 
                                                style="width: 100%;" 
                                                min="0"
                                                max="100"
                                                step="0.1"
                                            />
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>
                            </nz-row>
                            <nz-row nzJustify="end" style="gap: 8px;">
                                <button nz-button nzType="primary" (click)="savePricingTemplate(template)" [disabled]="!template.pricingName || template.pricingValue === null || template.pricingValue === undefined">
                                    @if(isTemplateUnsaved()) {
                                        <i nz-icon nzType="warning" nzTheme="outline"></i>
                                    } @else {
                                    <i nz-icon nzType="save" nzTheme="outline"></i>
                                    }
                                    Save Template
                                </button>
                                <button nz-button nzType="default" nzDanger (click)="removeTemplate(template.pricingTemplateId)">
                                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                                    {{isTemplateUnsaved() ? 'Cancel' : 'Remove'}}
                                </button>
                            </nz-row>
                            @if(isTemplateUnsaved()) {
                                <nz-alert 
                                    nzType="warning" 
                                    nzMessage="Please save the template before managing stock items" 
                                    nzShowIcon 
                                    [nzCloseable]="false"
                                    style="margin-top: 16px;"
                                ></nz-alert>
                            }
                        </nz-card>
                    </ng-template>

                <ng-template #SPTemplateHeader>
                    <nz-card [nzBordered]="false" style="background-color: #fafafa;"  >
                        <nz-card-meta
                        style="margin-bottom: 16px;"
                            nzTitle="Gross Profit Settings"
                            nzDescription="This percentage will be used to calculate the selling price based on the cost of each item."
                        ></nz-card-meta>
                        <nz-form-item style="margin-bottom: 0;">
                            <nz-form-label nzRequired>
                                Fixed GP % 
                                    <i nz-icon nzType="info-circle" nzTheme="outline" 
                                        nz-tooltip="Default gross profit percentage. Individual items can override this with fixed prices."
                                        style="margin-left: 4px; color: #1890ff; cursor: help;">
                                    </i>
                            </nz-form-label>
                            <nz-form-control>
                                <nz-input-group nzCompact style="display: flex; gap: 8px; align-items: center; max-width: 300px;">
                                    <input 
                                        nz-input 
                                        type="number" 
                                        [(ngModel)]="template.pricingValue" 
                                        placeholder="Enter percentage" 
                                        style="width: 150px;" 
                                        min="0"
                                        max="100"
                                        step="0.1"
                                    />
                                    <button nz-button nzType="primary" (click)="savePricingTemplate(template)">
                                        <i nz-icon nzType="save" nzTheme="outline"></i>
                                        Save
                                    </button>
                                </nz-input-group>
                            </nz-form-control>
                        </nz-form-item>
                    </nz-card>
                </ng-template>
                
                @if(!isTemplateUnsaved()) {
                <div>
                    <nz-tabs nzCentered>
                        <nz-tab nzTitle="Services & Other">
                            <nz-row style="margin-bottom: 16px;" nzJustify="space-evenly">
                                <nz-input-group [nzSuffix]="customSearchSuffixTemplate" style="width: 25%;">
                                    <input nz-input placeholder="Search by description or stock code" [(ngModel)]="stockCustomSearchTerm" />
                                </nz-input-group>
                                <ng-template #customSearchSuffixTemplate>
                                    @if(stockCustomSearchTerm()) {
                                        <i nz-icon nzType="close-circle" nzTheme="fill" (click)="clearCustomSearch()" style="cursor: pointer;"></i>
                                    }
                                </ng-template>
                            </nz-row>
                            <nz-table #customStockTable [nzData]="filteredStockCustomItems()"  [nzFrontPagination]="true" [nzPageSize]="25" [nzPaginationPosition]="'bottom'"  [nzLoading]="isLoading()">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th>Stock Code</th>
                                        <th>Cost</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of customStockTable.data; track item.stockCustomId) {
                                    <tr [ngClass]="{'highlighted-row': item.pricingRule}" [nz-tooltip]="item.pricingRule ? 'Fixed Price Applied' : ''">
                                        <td>{{item.description}}</td>
                                        <td>{{item.stockCode}}</td>
                                        <td>{{item.cost | number:'1.2-2'}}</td>
                                        <td nz-row nzJustify="start" style="display: flex; gap: 8px;">
                                            @if (selectedStockCustomItem() !== item) {
                                                <button nz-button nzType="primary" (click)="selectedStockCustomItem.set(item)" nz-tooltip="Add/Edit fixed price" style="display: flex; align-items: center; justify-content: space-between; width: 120px;">
                                                    <span>{{item.pricingRule ? (item.pricingRule.pricingValue | number:'1.2-2') : (item.price | number:'1.2-2')}}</span>
                                                    <i nz-icon nzType="edit" nzTheme="outline" style="cursor: pointer;"></i>     
                                                </button>
                                                @if(item.pricingRule) {
                                                    <button nz-button nzType="default">
                                                        <i nz-icon nzType="delete" nzTheme="outline" style="cursor: pointer;" (click)="removeStockCustomPricingRule(item)" nz-tooltip="Remove fixed price"></i>
                                                    </button>
                                                }
                                            } @else {
                                                <nz-row nzJustify="space-evenly" style="display: flex; align-items: center; gap: 8px;">
                                                    <input 
                                                        #customPriceInput
                                                        nz-input 
                                                        type="number" 
                                                        [ngModel]="item.pricingRule?.pricingValue ?? item.price" 
        
                                                        (keydown.enter)="saveStockCustomPricingRule(item, +customPriceInput.value); selectedStockCustomItem.set(null)"
                                                        (keydown.escape)="selectedStockCustomItem.set(null)"
                                                        style="width: 120px;" 
                                                        autofocus
                                                    />
                                                    <i nz-icon nzType="check" nzTheme="outline" style="cursor: pointer; color: #52c41a;" (click)="saveStockCustomPricingRule(item, +customPriceInput.value); selectedStockCustomItem.set(null)" nz-tooltip="Save"></i>
                                                    <i nz-icon nzType="close" nzTheme="outline" style="cursor: pointer; color: #ff4d4f;" (click)="selectedStockCustomItem.set(null)" nz-tooltip="Cancel"></i>
                                                </nz-row>
                                            }
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </nz-table>

                        </nz-tab>
                        <nz-tab nzTitle="Stock Items">
                            <nz-row style="margin-bottom: 16px;" nzJustify="space-evenly">
                                <nz-input-group [nzSuffix]="searchSuffixTemplate" style="width: 25%;">
                                    <input nz-input placeholder="Search by description or stock code" [(ngModel)]="stockSearchTerm" />
                                </nz-input-group>
                                <ng-template #searchSuffixTemplate>
                                    @if(stockSearchTerm()) {
                                        <i nz-icon nzType="close-circle" nzTheme="fill" (click)="clearSearch()" style="cursor: pointer;"></i>
                                    }
                                </ng-template>
                                @if(activeFilterCount() > 0) {
                                    <button nz-button nzType="default" (click)="clearFilters()">
                                        Clear Filters ({{activeFilterCount()}})
                                    </button>
                                }
                            </nz-row>
                            <nz-table #stockTable [nzData]="filteredStockItems()" [nzShowPagination]="true" [nzFrontPagination]="true" [nzPageSize]="10" [nzPaginationPosition]="'bottom'" [nzLoading]="isLoading()">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th>Stock Code</th>
                                        <th>Type</th>
                                        <th [nzFilterMultiple]="true"
                                            [nzFilters]="listofBrandsFilter()"
                                            (nzFilterChange)="selectedBrandIds.set($event)"
                                          >Brand</th>
                                        <th
                                        [nzFilterMultiple]="true"
                                        [nzFilters]="listOfSizesFilter()"
                                        (nzFilterChange)="selectedSizeIds.set($event)"
                                        >Size</th>
                                        <th>Cost</th>
                                        <th nzWidth="20%">Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of stockTable.data; track item.msfId) {
                                    <tr [ngClass]="{'highlighted-row': item.pricingRule}" [nz-tooltip]="item.pricingRule ? 'Fixed Price Applied' : ''">
                                        <td>{{item.description}}</td>
                                        <td>{{item.stockCode}}</td>
                                        <td>{{tyreType(item.tyreLocationId)}}</td>
                                        <td>{{item.tyreBrand}}</td>
                                        <td>{{item.genCode}}</td>
                                        <td>{{item.cost | number:'1.2-2'}}</td>
                                        <td nz-row nzJustify="start" style="display: flex; gap: 8px;">
                                            @if (selectedStockItem() !== item) {
                                                <button nz-button nzType="primary" (click)="selectedStockItem.set(item)" nz-tooltip="Add/Edit fixed price" style="display: flex; align-items: center; gap: 8px;">
                                                    <span>{{item.pricingRule ? (item.pricingRule.pricingValue | number:'1.2-2') : (item.price | number:'1.2-2')}}</span>
                                                    <i nz-icon nzType="edit" nzTheme="outline" style="cursor: pointer;" ></i>     
                                                </button>
                                                @if(item.pricingRule) {
                                                        <button nz-button nzType="default"><i nz-icon nzType="delete" nzTheme="outline" style="cursor: pointer;" (click)="removePricingRule(item)" nz-tooltip="Remove fixed price"></i></button>
                                                    }
                                            } @else {
                                                <nz-row nzJustify="center" style="display: flex; align-items: center; gap: 8px;">
                                                    <input 
                                                        #priceInput
                                                        nz-input 
                                                        type="number" 
                                                        [ngModel]="item.pricingRule?.pricingValue ?? item.price" 
                                                        (keydown.enter)="savePricingRule(item, +priceInput.value); selectedStockItem.set(null)"
                                                        (keydown.escape)="selectedStockItem.set(null)"
                                                        style="width: 120px;" 
                                                        autofocus
                                                    />
                                                    <i nz-icon nzType="check" nzTheme="outline" style="cursor: pointer; color: #52c41a;" (click)="savePricingRule(item, +priceInput.value); selectedStockItem.set(null)" nz-tooltip="Save"></i>
                                                    <i nz-icon nzType="close" nzTheme="outline" style="cursor: pointer; color: #ff4d4f;" (click)="selectedStockItem.set(null)" nz-tooltip="Cancel"></i>
                                                </nz-row>
                                            }
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </nz-table>
                        </nz-tab>

                    </nz-tabs>
                </div>
            }
        </nz-card>
        </nz-tab>
    }
    </nz-tabs>
</div>

<nz-modal
    [nzVisible]="isManualAddVisible()"
    (nzOnCancel)="isManualAddVisible.set(false);"
    nzTitle="Add Stock Item"
    [nzMaskClosable]="true"
>
    <ng-container *nzModalContent>
        <app-manual-add-stock-item></app-manual-add-stock-item>
    </ng-container>
</nz-modal>


